import { render, staticRenderFns } from "./AmlReportDetails.vue?vue&type=template&id=5f1aa11c&scoped=true&lang=pug"
import script from "./AmlReportDetails.vue?vue&type=script&lang=js"
export * from "./AmlReportDetails.vue?vue&type=script&lang=js"
import style0 from "./AmlReportDetails.vue?vue&type=style&index=0&id=5f1aa11c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1aa11c",
  null
  
)

export default component.exports